export class UserData {
    companyID: number = null;
    firstName: string = "";
    lastName: string = "";
    primaryPhone: string = "";
    emailID: string = "";
    psopUserManagerEmail: string = "";
    psopUserManagerRole: string = "";
    userTypeID: number = 1;
    userRoleID: number = 6;
    note: string = "";
    policyAdminAccessFlag: boolean = false;
    bdxPortalAccessFlag:boolean = false;
    safetyNowAccessFlag:boolean = false;
    producerCodes = [];
}
